var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTalkpalTextLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 40,
    viewBox: "0 0 28 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.77138 16.2195C5.77138 15.1436 5.34041 14.1325 4.5553 13.3725L3.08197 11.9434L0 14.9345L2.63095 17.4866C3.32418 18.159 3.70838 19.0535 3.71005 20.003C3.70838 20.9493 3.32418 21.8421 2.63095 22.5145L0 25.0666L3.08364 28.0561L4.55697 26.627C5.34041 25.867 5.77305 24.8559 5.77305 23.78V16.2178L5.77138 16.2195Z",
    fill: "#2E3BC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3636 23.7831V16.216C16.3636 15.1434 15.9326 14.1323 15.1475 13.3723L8.37884 6.80664L5.29688 9.79619L13.2231 17.4848C13.9164 18.1572 14.3006 19.0516 14.3022 20.0012C14.3006 20.9491 13.9164 21.8403 13.2231 22.5127L5.29688 30.2013L8.37884 33.1908L15.1475 26.6252C15.9326 25.8652 16.3636 24.8557 16.3636 23.7814",
    fill: "#2E3BC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9912 20.0275V20.0211C27.9912 17.7445 27.9945 15.4646 27.9995 13.9642C28.0029 12.8478 27.5736 11.814 26.7918 11.0557L15.396 0L11.123 4.14486L23.6814 16.3267C24.6937 17.3086 25.2533 18.613 25.2567 20C25.2533 21.3886 24.6937 22.693 23.6814 23.675L11.123 35.8551L15.396 40L26.7918 28.946C27.5752 28.1876 28.0045 27.1539 27.9995 26.0374C27.9945 24.5499 27.9912 22.2944 27.9912 20.034V20.0275Z",
    fill: "#2E3BC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalkpalTextLogo);
export default __webpack_public_path__ + "static/media/talkpal-text-logo.0e0d2f5aa45d93b2eb25e85b6205ddfd.svg";
export { ForwardRef as ReactComponent };